import React, { useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './movingDetails.scss';
import { StandaloneSearchBox, Autocomplete } from '@react-google-maps/api';
import { twoDecimalPlaces } from '../../utils/common';



const MovingDetails = (props) => {
  const startRef = useRef();
  const endRef = useRef();
  const [startPlace, setStartPlace] = useState(null);
  const [endPlace, setEndPlace] = useState(null);
  const [saveSender, setSaveSender] = useState(false);
  const [saveReceiver, setSaveReceiver] = useState(false);
  const [isSame, setIsSame] = useState(false);
  const [startCoordinate, setStartCoordinate] = useState(props?.senderDetails?.loc?.coordinates || []);
  const [endCoordinate, setEndCoordinate] = useState(props?.senderDetails?.loc?.coordinates || []);


  const handlePlaceChangedStart = (setFieldValue) => {
    const place = startRef.current.getPlace();
    if (place) {
      setStartCoordinate([place.geometry.location.lat(), place.geometry.location.lng()]);
      setFieldValue('senderAddress', place.formatted_address);
      setStartPlace(place)
    }
  };

  const handlePlaceChangedEnd = (setFieldValue) => {
    const place = endRef.current.getPlace();
    if (place) {
      setEndCoordinate([place.geometry.location.lat(), place.geometry.location.lng()]);
      setFieldValue('receiverAddress', place.formatted_address);
      setEndPlace(place)
    }
  };

  const validationSchema = Yup.object().shape({
    senderFirstName: Yup.string().required('This field is required'),
    // senderLastName: Yup.string().required('This field is required'),
    senderEmail: Yup.string().email('Invalid email').required('This field is required'),
    senderMobileNumber: Yup.string().matches(/^[0-9]{10}$/, 'Invalid mobile number').required('The phone number should be 10 digits long'),
    senderAddress: Yup.string().required('This field is required'),
    receiverFirstName: Yup.string().required('This field is required'),
    // receiverLastName: Yup.string().required('This field is required'),
    receiverEmail: Yup.string().email('Invalid email').required('This field is required'),
    receiverMobileNumber: Yup.string().matches(/^[0-9]{10}$/, 'Invalid mobile number').required('The phone number should be 10 digits long'),
    receiverAddress: Yup.string().required('This field is required'),
  });

  const handleSubmit = (values) => {
    // Handle form submission here
    let sender = {
      firstName: values?.senderFirstName,
      // lastName: values?.senderLastName,
      email: values?.senderEmail,
      phone: values?.senderMobileNumber,
      address: values?.senderAddress,
      loc: {
        type: 'Point',
        coordinates: startCoordinate
      }
    }

    let receiver = {
      firstName: values?.receiverFirstName,
      // lastName: values?.receiverLastName,
      email: values?.receiverEmail,
      phone: values?.receiverMobileNumber,
      address: values?.receiverAddress,
      loc: {
        type: 'Point',
        coordinates: endCoordinate
      }
    }
    props.setSenderDetails(sender);
    props.setReceiverDetails(receiver);
    props.setSaveSender(saveSender);
    props.setSaveReceiver(saveReceiver);
    props.setStartPlace(startPlace)
    props.setEndPlace(endPlace)
    props.handleTimeModal()
  };

  const handleSavedModal = (type) => {
    props.handleSavedAddressModal(type);
    props.setFormModal(false)
  }

  const handleClose = () => {
    props.setStartPlace(null);
    props.setEndPlace(null);
    props.setSenderDetails(null);
    props.setReceiverDetails(null);
    props.setFormModal(false);
    props.setSaveSender(false);
    props.setSaveReceiver(false);
    props.handleClearInputFields();
  }

  const handleIsSame = (val, setFieldValue, values) => {
    setIsSame(val);
    if (val) {
      setFieldValue('receiverFirstName', values?.senderFirstName)
      setFieldValue('receiverLastName', values?.senderLastName)
      setFieldValue('receiverEmail', values?.senderEmail)
      setFieldValue('receiverPhone', values?.senderPhone)
      setFieldValue('receiverAddress', values?.senderAddress)
      props.setEndPlace(props.startPlace)
    } else {
      setFieldValue('receiverFirstName', '')
      setFieldValue('receiverLastName', '')
      setFieldValue('receiverEmail', '')
      setFieldValue('receiverPhone', '')
      setFieldValue('receiverAddress', '')
      props.setEndPlace(null)
    }
  }

  return (
    <>
      <Modal show={props.formModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header className='z-3 position-relative' onClick={() => handleClose()} closeButton>
          <Modal.Title>Add Pick Up & Receiver Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body className='z-1 position-relative'>
          <Formik
            initialValues={{
              senderFirstName: props.senderDetails?.firstName || `${props.senderData?.firstName} ${props.senderData?.lastName}` || '',
              // senderLastName: props.senderDetails?.lastName || '',
              senderEmail: props.senderDetails?.email || props.senderData?.email || '',
              senderMobileNumber: props.senderDetails?.phone || props.senderData?.phone || '',
              senderAddress: props.senderDetails?.address || '',
              receiverFirstName: props.receiverDetails?.firstName || '',
              // receiverLastName: props.receiverDetails?.lastName || '',
              receiverEmail: props.receiverDetails?.email || '',
              receiverMobileNumber: props.receiverDetails?.phone || '',
              receiverAddress: props.receiverDetails?.address || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values, errors, touched }) => (
              <FormikForm className="w-100 moving-detail-form">
                <Row className='g-5'>
                  <Col md={6} className='sender-wrap'>
                    <Row className='g-3'>
                      <div className='form-title'> Pick Up details </div>
                      <Col sm={6} className={touched.senderFirstName && errors.senderFirstName ? 'error' : ''}>
                        <Form.Label>Name<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="senderFirstName"
                          as={Form.Control}
                          placeholder="Enter name"
                        />
                        <ErrorMessage
                          name="senderFirstName"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      {/* <Col sm={6} className={touched.senderLastName && errors.senderLastName ? 'error' : ''}>
                        <Form.Label>Last name<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="senderLastName"
                          as={Form.Control}
                          placeholder="Enter last name"
                        />
                        <ErrorMessage
                          name="senderLastName"
                          component="div"
                          className="error-message"
                        />
                      </Col> */}
                      <Col sm={6} className={touched.senderEmail && errors.senderEmail ? 'error' : ''}>
                        <Form.Label>Email address<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="senderEmail"
                          as={Form.Control}
                          placeholder="Enter email address"
                        />
                        <ErrorMessage
                          name="senderEmail"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Col sm={6} className={touched.senderMobileNumber && errors.senderMobileNumber ? 'error' : ''}>
                        <Form.Label>Mobile number<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="senderMobileNumber"
                          as={Form.Control}
                          placeholder="Enter mobile number"
                        />
                        <ErrorMessage
                          name="senderMobileNumber"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Col xs={12} className={touched.senderAddress && errors.senderAddress ? 'error' : ''}>
                        <Form.Label>Address<span className='req-field'>*</span></Form.Label>
                        <Autocomplete
                          onLoad={ref => startRef.current = ref}
                          onPlaceChanged={() => handlePlaceChangedStart(setFieldValue)}
                          options={{
                            componentRestrictions: { country: 'BM' }, // Restricting search to Bermuda
                            fields: ['formatted_address', 'geometry'], // Specify the fields you need
                          }}

                        >
                          <Field
                            as={Form.Control}
                            name="senderAddress"
                            rows={3}
                            placeholder="Tell us the street address or business name for pick up"
                          />
                        </Autocomplete>
                        <ErrorMessage
                          name="senderAddress"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Form.Check // prettier-ignore
                        type='checkbox'
                        checked={saveSender}
                        onClick={() => setSaveSender(!saveSender)}
                        label='Save sender details'
                      />
                      <a href='javascript:void(0)' className='link-underline-primary' onClick={() => handleSavedModal('sender')}>Get from saved address</a>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='g-3'>
                      <div className='form-title d-flex justify-content-between align-center'>
                        <span>Receiver Details</span>
                        {/* <Form.Check // prettier-ignore
                          type='checkbox'
                          checked={isSame}
                          onClick={()=>handleIsSame(!isSame, setFieldValue, values)}
                          label='Same as sender'
                        /> */}

                      </div>
                      <Col sm={6} className={touched.receiverFirstName && errors.receiverFirstName ? 'error' : ''}>
                        <Form.Label>Name<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="receiverFirstName"
                          as={Form.Control}
                          placeholder="Enter name"
                          className='error'
                        />
                        <ErrorMessage
                          name="receiverFirstName"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      {/* <Col sm={6} className={touched.receiverLastName && errors.receiverLastName ? 'error' : ''}>
                        <Form.Label>Last name<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="receiverLastName"
                          as={Form.Control}
                          placeholder="Enter last name"
                        />
                        <ErrorMessage
                          name="receiverLastName"
                          component="div"
                          className="error-message"
                        />
                      </Col> */}
                      <Col sm={6} className={touched.receiverEmail && errors.receiverEmail ? 'error' : ''}>
                        <Form.Label>Email address<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="receiverEmail"
                          as={Form.Control}
                          placeholder="Enter email address"
                        />
                        <ErrorMessage
                          name="receiverEmail"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Col sm={6} className={touched.receiverMobileNumber && errors.receiverMobileNumber ? 'error' : ''}>
                        <Form.Label>Mobile number<span className='req-field'>*</span></Form.Label>
                        <Field
                          type="text"
                          name="receiverMobileNumber"
                          as={Form.Control}
                          placeholder="Enter mobile number"
                        />
                        <ErrorMessage
                          name="receiverMobileNumber"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Col xs={12} className={touched.receiverAddress && errors.receiverAddress ? 'error' : ''}>
                        <Form.Label>Address<span className='req-field'>*</span></Form.Label>
                        <Autocomplete
                          onLoad={ref => endRef.current = ref}
                          onPlaceChanged={() => handlePlaceChangedEnd(setFieldValue)}
                          options={{
                            componentRestrictions: { country: 'BM' }, // Restricting search to Bermuda
                            fields: ['formatted_address', 'geometry'], // Specify the fields you need
                          }}
                        >
                          <Field
                            as={Form.Control}
                            name="receiverAddress"
                            rows={3}
                            placeholder="Tell us the street address or business name for pick up"
                          />
                        </Autocomplete>
                        <ErrorMessage
                          name="receiverAddress"
                          component="div"
                          className="error-message"
                        />
                      </Col>
                      <Form.Check // prettier-ignore
                        type='checkbox'
                        checked={saveReceiver}
                        onClick={() => setSaveReceiver(!saveReceiver)}
                        label='Save receiver details'
                      />
                      <a href='javascript:void(0)' className='link-underline-primary' onClick={() => handleSavedModal('receiver')}>Get from saved address</a>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  {
                    props.startPlace && props.endPlace && props.routeDetails ?
                      <>
                        <p>{props.routeDetails?.distance}, ({twoDecimalPlaces(props.routeDetails?.durationInMin)} min)</p>
                      </>
                      : null
                  }
                </Row>
                <div className='d-flex justify-content-center w-100 form-footer'>
                  <Button type='submit' variant='primary'>Submit</Button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default MovingDetails;
